import Helpers from '../helpers';

export default class Native {

  /**
   * Gets the fluid native slot definition for a particular slot ID
   *
   * @param id              - Native Ad Slot ID
   * @param definitions     - Prebid responsive slot definitions config
   * @returns {Promise<{}>} - Slot Data
   */
  static async getSlotData( id, definitions ) {

    let slotData = {};

    // find the requested slot data
    for ( let i = 0; i < definitions.length; i++ ) {

      if ( id === definitions[i].id ) {
        slotData = definitions[i];
      }

    }

    return slotData;

  }

  /**
   * Gets a fluid slot definition for a particular slot and if not found looks for a more generic definition and returns one if found
   *
   * @param id              - Native Ad Slot ID
   * @param definitions     - Prebid responsive slot definitions config
   * @returns {Promise<{}>} - Slot Data
   */
  static async getSlot( id, definitions ) {

    let slot     = await this.getSlotData( id, definitions );
    let id_parts = id.split( '-' );

    // if a slot definition matching the id is not found try a less specific one
    if ( ! slot.id ) {

      id_parts.shift();
      id = id_parts.join( '-' );

      slot = await this.getSlotData( id, definitions );

    }

    // if a slot definition is still not found try an even less specific one
    if ( ! slot.id ) {

      id_parts = id.split( '-' );
      id_parts.shift();

      id   = id_parts.join( '-' );
      slot = await this.getSlotData( id, definitions );
    }

    return slot;

  }

  /**
   * Places a native ad slot on page, optionally hiding the target anchor element
   *
   * @param id                     - Ad Slot ID
   * @param anchorElement          - Target anchor element
   * @param adSlotContainerClass   - Desired container class for the ad slot
   * @param adSlotContainerElement - Desired container element for the ad slot
   * @param hidePreceding          - Whether or not to hide the anchor element
   * @returns {Promise<Boolean>}
   */
  static async placeSlot( id, anchorElement, adSlotContainerClass, adSlotContainerElement, hidePreceding = true ) {

    // Select the desired placement anchor element
    anchorElement = document.querySelector( anchorElement );

    // If we can't find it don't proceed with placement
    if ( ! anchorElement ) {
      return false;
    }

    // Hide the anchor element if desired
    if ( hidePreceding ) {
      anchorElement.style.display = 'none';
    }

    // Create a new container with the appropriate class
    let newContainer = document.createElement( adSlotContainerElement );

    // Assign a class to the container if supplied
    if ( adSlotContainerClass ) {
      newContainer.className = adSlotContainerClass;
    }

    // Insert the new fluid ad container after the selected article block
    let container = anchorElement.parentNode.insertBefore( newContainer, anchorElement.nextSibling );

    // Insert the fluid ad slot into the new container
    let fluidSlot       = '<div id="' + id + '" class="dfp-ad" rel="advert" data-slot-type="fluid-native"></div>';
    container.innerHTML = fluidSlot;

    return true;

  }

  /**
   * Places a native ad slot into a specific container - Intended for cases 
   * where there is not a targetable anchor element within the container
   *
   * @param id                     - Ad Slot ID
   * @param container              - Target container
   * @param adSlotContainerClass   - Desired container class for the ad slot
   * @param adSlotContainerElement - Desired container element for the ad slot
   * @returns {Promise<Boolean>}
   */
  static async placeSlotInContainer( id, container, adSlotContainerClass, adSlotContainerElement ) {

    container = document.querySelector( container );

    // If we can't find the container or it's not empty don't proceed with placement
    if ( ! container || ! Helpers.hasChildren( container ) ) {
      return false;
    }

    // Create a new container with the appropriate class
    let newContainer = document.createElement( adSlotContainerElement );

    // Assign a class to the container if supplied
    if ( adSlotContainerClass ) {
      newContainer.className = adSlotContainerClass;
    }

    container = container.appendChild( newContainer );

    // Insert the fluid ad slot into the new container
    let fluidSlot       = '<div id="' + id + '" class="dfp-ad" rel="advert" data-slot-type="fluid-native" data-slot-style="direct-placement"></div>';
    container.innerHTML = fluidSlot;

    return true;

  }

}